import { Button, ButtonProps, makeStyles, Theme } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { css } from "@emotion/react";

interface Props extends ButtonProps {
  label?: string;
  loading?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 55,
    width: "100%",
    color: "#fff",
    borderRadius: 31,
    letterSpacing: 0,
    fontSize: 18,
    fontWeight: 600,
    textTransform: "none",
    backgroundColor: "#000000",
    fontFamily: '"Poppins", sans-serif',
    "&:hover": {
      backgroundColor: "#565656",
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
  },
  spinnerContainer: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    width: "100%",
    height: "100%",
  },
}));

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

export const SecondaryButton: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  const spinner = (
    <div className={classes.spinnerContainer}>
      <PulseLoader color="#fff" loading={props.loading} css={override} size={5} />
    </div>
  );

  return (
    <Button className={classes.root} {...props}>
      {!props.loading && (props.label || "Falta label")}
      {props.loading && spinner}
    </Button>
  );
};

export default SecondaryButton;
